<template>
  <div>
    <el-table :data="blenderData" style="width: 100%">
      <el-table-column label="辊压机">
        <el-table-column
          prop="filedName"
          label="设备信息名称"
          width="120"
        >
        </el-table-column>
        <el-table-column prop="filedUnit" label="信息单位" width="120">
        </el-table-column>
        <el-table-column prop="maxValue" label="最大值" width="120">
        </el-table-column>
        <el-table-column prop="minValue" label="最小值" width="120">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="primary" plain
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <!-- 点击编辑弹窗 -->
    <el-dialog title="编辑" :visible.sync="dialogFormVisible">
      <el-form :model="blenderForm">
        <el-form-item label="设备信息名称" :label-width="formLabelWidth">
          <el-input
            v-model="blenderForm.filedName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="信息单位" :label-width="formLabelWidth">
          <el-input v-model="blenderForm.filedUnit" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最大值" :label-width="formLabelWidth">
          <el-input v-model="blenderForm.maxValue" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最小值" :label-width="formLabelWidth">
          <el-input v-model="blenderForm.minValue" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="blenderUpdates()"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {feedingList,feedingUpdate} from'@/assets/api/feedingStyle'
export default {
  data() {
    return {
      dialogFormVisible: false,
      dialogFormVisible: false,
      //编辑页面的数据对象
      blenderForm: {
        machineId: "MC004",
        machineName: "",
        filedKey: "",
        filedName: "",
        filedUnit: "",
        isChoose: 0,
        maxValue: "",                                      
        minValue: "",
        value: "",
      },
      formLabelWidth: "120px",
      //搅拌机数据
      blenderData: [],
    };
  },
  created(){
    this.blenderQuery();
  },
  methods: {
    //查询搅拌机List
    blenderQuery(){
      feedingList(this.blenderForm).then(res=>{
       this.blenderData = res.data;
      })
    },
    //点击编辑按钮赋值给编辑页面框
    handleClick(row) {
      this.dialogFormVisible = true;
        this.blenderForm.machineId= row.machineId;
        this.blenderForm.machineName= row.machineName;
        this.blenderForm.filedKey= row.filedKey;
        this.blenderForm.filedName= row.filedName;
        this.blenderForm.filedUnit= row.filedUnit;
        this.blenderForm.isChoose=row.isChoose;
        this.blenderForm.maxValue= row.maxValue;
        this.blenderForm.minValue= row.minValue;
        this.blenderForm.value= row.value;
    },
    //修改搅拌机数据
    blenderUpdates(){
      this.dialogFormVisible = false;
      feedingUpdate(this.blenderForm).then(res=>{
        this.blenderQuery();
      })
    }
  },
};
</script>
<style lang="less">
.el-table .cell {
  color: #000;
  text-align: center;
  font-size: 17px;
}
</style>